import { Injectable } from '@angular/core';
import { JeevesCustomerActionConfigService } from 'gung-standard-jeeves';

@Injectable({
  providedIn: 'root'
})
export class CarLinerCustomerActionConfigService extends JeevesCustomerActionConfigService {
  base = [];
}
